const UnitConverter = {
  methods: {

    toPpm (key, unit, val) {
      if(val === null) {
        return null;
      }

      const result = this.$store.getters['nutrients/getPPmFromUnit'](key, unit, val);

      return result;
    },

    toUnit (key, unit, val) {
      if(val === null) {
        return null;
      }

      const result = this.$store.getters['nutrients/getUnitFromPPm'](key, unit, val);

      return result;
    },

    round(val) {
      if(!val) return '';
      return Math.round((parseFloat(val) + Number.EPSILON) * 100) / 100
    }
  }
}

export { UnitConverter };